import { apiRequest } from './api'

export const dashboardService = {
  // Get all dashboard metrics in one call
  getDashboardSummary: async () => {
    try {
      const response = await apiRequest('/admin/dashboard/summary', {
        method: 'GET',
      })

      return {
        success: true,
        data: response.data,
        message: 'Dashboard summary fetched successfully',
      }
    } catch (error) {
      return {
        success: false,
        error: error.message,
        message: 'Failed to fetch dashboard summary',
        data: null,
      }
    }
  },
}
